import script from "./BasicMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicMenu.vue?vue&type=script&setup=true&lang=js"

import "./BasicMenu.vue?vue&type=style&index=0&id=9869a51c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9869a51c"]])

export default __exports__